import { useQuery } from 'react-query';
import request from '../../../helpers/request';

const key = () => ['appSections'];

const getAppSectionsList = async () => {
  return await request.get(
    `/Information/app_sections`,
    {},
    'При получении внутренних ссылок произошла ошибка'
  );
};

const useAppSectionsQuery = (options) =>
  useQuery(key(), getAppSectionsList, options);

export default useAppSectionsQuery;
